export function normalizeTipoCalculoJuros(raw) {
  const s = String(raw ?? "")
    .trim()
    .toLowerCase();
  if (["total", "taxa_total", "erp", "juros_total"].includes(s)) return "total";
  return "ao_mes";
}

function roundMoney(v) {
  return Math.round(Number(v) * 100) / 100;
}

function normalizeInstallmentItems(raw) {
  if (!Array.isArray(raw) || !raw.length) return [];
  const out = [];
  for (const it of raw) {
    if (!it || typeof it !== "object") continue;
    const unit = Number(
      it.unitPrice ?? it.price ?? it.valor ?? it.preco ?? it.unit_price ?? 0
    );
    const qty = Number(it.qty ?? it.quantidade ?? it.quantity ?? 1);
    if (!(unit > 0) || !(qty > 0) || !Number.isFinite(unit) || !Number.isFinite(qty)) {
      continue;
    }
    out.push({ unitPrice: unit, qty: Math.max(1, Math.floor(qty)) });
  }
  return out;
}

function applyTotalRate(amount, rate) {
  return roundMoney(Number(amount) * (1 + rate));
}

function totalWithTaxaTotal(baseNum, rate, items) {
  const lines = normalizeInstallmentItems(items);
  if (!lines.length) return applyTotalRate(baseNum, rate);

  let itemsSubtotal = 0;
  let itemsWithInterest = 0;
  for (const it of lines) {
    itemsSubtotal += it.unitPrice * it.qty;
    itemsWithInterest += applyTotalRate(it.unitPrice, rate) * it.qty;
  }
  itemsSubtotal = roundMoney(itemsSubtotal);
  itemsWithInterest = roundMoney(itemsWithInterest);

  const extra = roundMoney(baseNum - itemsSubtotal);
  if (Math.abs(extra) >= 0.005) {
    itemsWithInterest = roundMoney(itemsWithInterest + applyTotalRate(extra, rate));
  }
  return itemsWithInterest;
}

export function applyPaymentMethodInterest(base, pm, installments = 1, items) {
  const baseNum = Number(base);
  const n = Math.max(1, Math.floor(Number(installments) || 1));
  const sem = Number(pm?.parcelas_semjuros || 0);
  const taxa = Number(pm?.juros_parcelamento || 0);
  const tipo = normalizeTipoCalculoJuros(pm?.tipo_calculo_juros);
  if (!(baseNum > 0) || !(taxa > 0)) {
    return { amount: roundMoney(baseNum), adj: 0, parcela: baseNum / n, comJuros: false, tipo, n };
  }
  const aplicaJuros = sem === 0 || n > sem;
  if (!aplicaJuros) {
    return { amount: roundMoney(baseNum), adj: 0, parcela: baseNum / n, comJuros: false, tipo, n };
  }
  if (tipo === "total") {
    const total = totalWithTaxaTotal(baseNum, taxa / 100, items);
    return {
      amount: total,
      adj: roundMoney(total - baseNum),
      parcela: total / n,
      comJuros: true,
      tipo,
      n,
    };
  }
  const i = taxa / 100;
  const fator = Math.pow(1 + i, n);
  const parcela = (baseNum * (i * fator)) / (fator - 1);
  const total = parcela * n;
  return {
    amount: roundMoney(total),
    adj: roundMoney(total - baseNum),
    parcela,
    comJuros: true,
    tipo,
    n,
  };
}

export function maxInstallmentsForPaymentMethod(pm) {
  const sem = Number(pm?.parcelas_semjuros || 0);
  const com = Number(pm?.parcelas_comjuros || 0);
  const configured = Math.max(sem, com);
  return configured > 0 ? configured : 1;
}
